import { useMutation, useQueryClient } from 'react-query';
import FeatureFlagsApi from '../FeatureFlagsApi';
import { FeatureFlag, UpdateFeatureFlagInput } from '../types';
import { evaluatedFeatureFlagsQueryKey } from '../../../shared/featureFlags/useEvaluatedFeatureFlagsQuery';
import { featureFlagsQueryKey } from './queryKeys';

interface UpdateArgs {
    key: string;
    input: UpdateFeatureFlagInput;
}

export function useUpdateFeatureFlagMutation() {
    const queryClient = useQueryClient();

    return useMutation<FeatureFlag, unknown, UpdateArgs>(
        ({ key, input }) => FeatureFlagsApi.update(key, input),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([featureFlagsQueryKey]);
                queryClient.invalidateQueries([evaluatedFeatureFlagsQueryKey]);
            }
        }
    );
}
